import Vue from 'vue';
import { gsap } from 'gsap';

Vue.component('reading-time-component', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            readingTime: '',
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.initReadingTime();
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        initReadingTime() {
            const text = document.getElementById('page-container').innerText;
            const wpm = 225;
            const words = text.trim().split(/\s+/).length;
            const time = Math.round(words / wpm);
            let timeText = `${time} minuten`;
            if (time < 1) {
                timeText = ' minder dan een minuut';
            } else if (time === 1) {
                timeText = `${time} minuut`;
            }
            this.readingTime = timeText;
        },
    },
});
